module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['wrap', _vm.wrapClass && 'wrap2'],
    style: (_vm._px2rem(_vm._wrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "content weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.isShowMain) ? _c('div', {
    staticClass: "main weex-ct weex-div",
    style: ({
      marginRight: _vm._px2rem(_vm.prompt.length ? _vm.themeStyle.lineMarginRight : '0px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "dot weex-ct weex-div",
    style: ({
      backgroundColor: _vm.options[_vm.active]['dotColor']
    }),
    attrs: {
      "weex-type": "div"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mainText weex-el weex-text",
    style: (_vm._processExclusiveStyle(_vm._mainTextColor, 75, 'text')),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.options[_vm.active]['text']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.prompt), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "promptBox weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "fakeBorder weex-ct weex-div",
      style: ({
        backgroundColor: !_vm.isShowMain && i === 0 ? 'transparent' : _vm._borderColor
      }),
      attrs: {
        "weex-type": "div"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: " weex-ct weex-div",
      class: ['prompt'],
      style: ({
        paddingLeft: _vm._px2rem(!_vm.isShowMain && i === 0 ? '0px' : _vm.themeStyle.linePaddingLeft, 75),
        marginRight: _vm._px2rem(i === _vm.prompt.length - 1 ? '0px' : _vm.themeStyle.lineMarginRight, 75)
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: " weex-el weex-text",
      class: [item.promptText2 ? 'smallPromptText' : 'promptText'],
      style: (_vm._processExclusiveStyle(_vm._promptTextColor, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.promptText))]), _c('p', {
      staticClass: " weex-el weex-text",
      class: [item.promptText2 ? 'smallPromptText' : 'promptText'],
      style: (_vm._processExclusiveStyle(_vm._promptTextColor, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item.promptText2))])])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a804fed", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a804fed","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-status/index.vue
// module id = 616
// module chunks = 0 1